/**
 * ============================================================================
 * EL-ARO
 * COMPONENT: Mobile Drawer
 * ============================================================================
 */

class ElaroMobileDrawer {

    constructor() {

        this.drawer = document.querySelector(
            "[data-mobile-drawer]"
        );

        if (!this.drawer) return;

        this.openButtons = document.querySelectorAll(
            "[data-mobile-menu-toggle]"
        );

        this.closeButtons = this.drawer.querySelectorAll(
            "[data-mobile-drawer-close]"
        );

        this.bindEvents();

    }

    bindEvents() {

        this.openButtons.forEach(button => {

            button.addEventListener(

                "click",

                () => this.open()

            );

        });

        this.closeButtons.forEach(button => {

            button.addEventListener(

                "click",

                () => this.close()

            );

        });

        document.addEventListener(

            "keydown",

            event => {

                if (

                    event.key === "Escape" &&
                    this.drawer.classList.contains("is-open")

                ) {

                    this.close();

                }

            }

        );

    }

    open() {

        this.drawer.classList.add("is-open");

        this.drawer.setAttribute(

            "aria-hidden",

            "false"

        );

        document.body.style.overflow = "hidden";

    }

    close() {

        this.drawer.classList.remove("is-open");

        this.drawer.setAttribute(

            "aria-hidden",

            "true"

        );

        document.body.style.overflow = "";

    }

}

document.addEventListener(

    "DOMContentLoaded",

    () => {

        new ElaroMobileDrawer();

    }

);